module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-103@2x__2182c8877349c8d9b697ab2c1495efb2.png";